// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/mini-cart/mini-cart';
import 'snippets/_containers/form/form-increment';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/country-modal/country-modal';

// Styles
import './_cart.scss';
